
import close_icon from '../../../assets/images/icons/close-icon.png'
import waiting_icon from '../../../assets/images/icons/waiting-icon.png'

import CancelButton from '../../../components/loadingButton/modelCancelButton';
import {useHistory} from 'react-router-dom'





const WaitingForPaymant = (props)=>{
    const history = useHistory()


    const {paymentDetails} = props

    return(
        <div>
            <div className="model-body">
                <div className="d-flex model-title">
                    <span>Waiting for payment </span>
                    <div 
                        className="d-flex close-ctn"
                        onClick={props.hide}>
                        <span>close</span>
                        <img src={close_icon}/>
                    </div>
                </div>
                <br/>
                <div className="waiting-payment-body">
                    {/* <div>
                        <img src={waiting_icon}/>
                    </div> */}
                    <br/>
                    <span>
                        <span style={{
                            fontWeight: 'bold',
                        }}>
                            Thank you for initiating this payment. 
                        </span>
                         <br/> <br/>
                        Please make sure you confirm payment with a popup <br/>
                        that is going to appear on your paying phone number {props.phoneNumber} <br/>
                        or <br/>
                        Dial *182*7# to check <br/>
                        your pending MoMo payments 
                    </span>
                </div>  
                <div 
                    style={{
                        width: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent:"center",
                        margin: '30px 0px'
                        }}>
                    <CancelButton 
                        title="OK"
                        // submit={()=>{props.hide(); history.push(
                        //     {pathname: '/applicant/checking-payment',
                        //         state: paymentDetails}
                        //     )}}
                        submit={()=>{props.hide(); history.push(
                            {pathname: '/dashboard',
                                // state: paymentDetails
                            }
                            )}}
                        />
                </div>  
          </div> 
        </div>
    )
}

export default WaitingForPaymant